import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import {
  getColorOptions,
  getFontPickerOptions,
  getFontSizeOptions,
  getFontStyleOptions,
  getFontWeightOptions,
  getLineHeightOptions,
  getTextAlignOptions,
  getTextDecorationOptions,
  getTextTransformOptions,
} from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { p2DefaultStyles } from "./defaultStyles";

export const p2DefaultData: BaseBlock = {
  id: uuidv4(),
  type: "p",
  props: {
    text: {
      prop: "other",
      type: "textarea",
      value: "Paragraph text",
    },
    paragraphStyle: {
      prop: "other",
      type: "paragraph-style-picker",
      value: "p2",
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        color: getColorOptions(p2DefaultStyles.color),
        textTransform: getTextTransformOptions(p2DefaultStyles.textTransform),
        fontStyle: getFontStyleOptions(p2DefaultStyles.fontStyle),
        fontWeight: getFontWeightOptions(p2DefaultStyles.fontWeight),
        fontSize: getFontSizeOptions(p2DefaultStyles.fontSize),
        fontFamily: getFontPickerOptions(p2DefaultStyles.fontFamily),
        lineHeight: getLineHeightOptions(p2DefaultStyles.lineHeight),
        textAlign: getTextAlignOptions(p2DefaultStyles.textAlign),
        textDecoration: getTextDecorationOptions(
          p2DefaultStyles.textDecoration,
        ),
        margin: getMarginOptions({
          defaultValue: p2DefaultStyles.margin,
        }),
        padding: getPaddingOptions({
          defaultValue: p2DefaultStyles.padding,
        }),
      },
    },
  },
};
